import md5 from 'crypto-js/md5.js'

const LIBRAVATAR_SERVER = 'https://libravatar.stendahls.dev';

const DEFAULT_IMAGES = [
    'https://cdn.stendahls.live/stendahls/avatar-placeholders/placeholder-1.jpg',
    'https://cdn.stendahls.live/stendahls/avatar-placeholders/placeholder-2.jpg',
    'https://cdn.stendahls.live/stendahls/avatar-placeholders/placeholder-3.jpg',
    'https://cdn.stendahls.live/stendahls/avatar-placeholders/placeholder-4.jpg',
    'https://cdn.stendahls.live/stendahls/avatar-placeholders/placeholder-5.jpg',
    'https://cdn.stendahls.live/stendahls/avatar-placeholders/placeholder-6.jpg',
];

// Deterministic per-email pick rather than Math.random() — the fallback image
// must stay the same across re-renders/data refreshes, otherwise a person
// without a real avatar appears to change photo (or "jump") every time the
// WiFi data updates even though their position hasn't changed.
const getDefaultImageURL = function getDefaultImageURL(email){
    const hash = md5( email ).toString();
    const index = parseInt( hash.slice( 0, 8 ), 16 ) % DEFAULT_IMAGES.length;

    return DEFAULT_IMAGES[ index ];
};

const libravatarImage = (email, size = 512) => {
    return `${ LIBRAVATAR_SERVER }/avatar/${ md5( email ) }?s=${size}&default=${ encodeURIComponent( getDefaultImageURL( email ) ) }&w=512&h=512&t=square&a=center`;
};

export default libravatarImage;
